import { get } from 'lodash';
import React from 'react';
import { ANTRAGSINFORMATIONEN_VORZEITIGER_MASSNAHMEBEGINN } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { isTrue } from 'src/utils/helper';
import { checkIfHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import VorzeitigeMassnahmeGlobal, { getFormStrucVorzeitigeMassnahmeGlobal } from './content/VorzeitigeMassnahmeGlobal';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import FoerderProgrammSchema from 'src/lib/paths/foerderprogramm_FULL_Paths.json';
const P = AntragSchema.attributes;
const FP_P = FoerderProgrammSchema.attributes;

export const TreeStructureAntragVorzeitigerMassnahme = (application: any, readOnly: boolean): TreeNodeType[] => {
	let treeNodes: TreeNodeType[] = [];

	const foerderprogramm = get(application, P.Foerderprogramm.path, {});
	const hasCommentVorzeitigeMassnahme = checkIfHasComment(
		readOnly,
		application,
		P.Vorzeitiger_Vorhabenbeginn.schema.attributes.Vorzeitiger_Vorhabenbeginn_Pruefung_Pruefstatus.path,
	);
	if (
		get(foerderprogramm, FP_P.Antragsinformationen_Vorzeitiger_Massnahmebeginn.path) ===
			ANTRAGSINFORMATIONEN_VORZEITIGER_MASSNAHMEBEGINN.AbAntragstellungMoeglich ||
		isTrue(get(application, P.Allgemein_Vorzeitiger_Vorhabenbeginn_Freigeschaltet.path))
	) {
		treeNodes = [
			{
				label: 'Vorzeitiger Vorhabenbeginn',
				content: <VorzeitigeMassnahmeGlobal hasComment={hasCommentVorzeitigeMassnahme} />,
				formStruc: getFormStrucVorzeitigeMassnahmeGlobal(application),
				hasComment: hasCommentVorzeitigeMassnahme,
			},
		];
	}

	return treeNodes;
};
